import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchEditMeta } from 'services/vendorOnboarding/api';
import VendorOnboardingLayout from './VendorOnboardingLayout';
import VendorOnboardingForm from './VendorOnboardingForm';

const VendorOnboardingEdit = () => {
  // vendorId is URL-safe base64 from the edit email link — pass as-is to the API.
  const { vendorId } = useParams();
  const [meta, setMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setIsLoading(true);
      const res = await fetchEditMeta(vendorId);
      if (cancelled) return;
      setIsLoading(false);
      if (!res.success) {
        toast.error(res.message || 'Unable to load vendor');
        return;
      }
      setMeta(res.data);
    })();
    return () => {
      cancelled = true;
    };
  }, [vendorId]);

  return (
    <VendorOnboardingLayout title="Vendor Edition Form" isLoading={isLoading}>
      {!isLoading && meta && (
        <VendorOnboardingForm mode="edit" meta={meta} />
      )}
    </VendorOnboardingLayout>
  );
};

export default VendorOnboardingEdit;
